import { useEffect, useState } from "react";
import { linieHeaderExtra } from "../Tabellen/ConstTabKopf/LinienKopf";
import GeneralTable from "../Tabellen/GeneralTable";
import DatenLaden from '../Tabellen/DatenLaden';
import InformationCell from "../Tabellen/InformationCell";
import LinieCreate from "./LinieCreate";
import StammdatenExport from "../Stammdaten/StammdatenExport";

export function Linien({ instance, vmInstance, setTable, goBack }) {
    const [dataLinien, setDataLinien] = useState();

    useEffect(() => {
        instance.getLinieLinieGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('load linien');
                setDataLinien(data);
            }
        });
    }, [instance]);

    const reloadData = () => {
        setDataLinien();
        let loading = new Promise((result) => {
            instance.getLinieLinieGet((error, data, response) => {
                if (error) {
                    console.log(error);
                } else {
                    result(data);
                }
            });
        });
        loading.then(d => setDataLinien(d));
    }

    const commCol = {
        id: "comment",
        Header: "",
        keyword: "info",
        Cell: ({ row }) => (
            <div>
                <InformationCell comment={row.original.kommentar} />
            </div>
        )
    }
    const csvIt = loadedData => {
        return loadedData.map(it =>
        ({
            ...it,
            Linie: it.linie,
            Verkehrsmittel: it.vm,
            Kommentar: it.kommentar,
        }))
    }
    return (
        <div>
            <LinieCreate instance={instance} reloadData={reloadData} vmInstance={vmInstance} />
            {dataLinien ? <div>
                <GeneralTable data={dataLinien} columns={linieHeaderExtra} hiddenColumns={['id', 'id_vm']} additionalColumns={[commCol]} />
                <StammdatenExport csvedData={csvIt(dataLinien)} csvHeader={['Linie', 'Verkehrsmittel', 'Kommentar']} csvFilename={"sd_linien"} />
                <aside style={{ fontSize: "small" }}>*Das Bearbeiten dieser Datensätze ist nicht vorgesehen.</aside>
            </div>
                : <DatenLaden />}
        </div>
    );
}
